export const minuteList  = [
    { key: '*', value: 'Every Minute' },
    { key: '*/5', value: 'Every 5th Minute' },
    { key: '*/15', value: 'Every 15th Minute'},
    { key: '*/30', value: 'Every 30th Minute' },
    { key: '0', value: '0' },
    { key: '1', value: '1' },
    { key: '2', value: '2' },
    { key: '3', value: '3' },
    { key: '4', value: '4' },
    { key: '5', value: '5' },
    { key: '6', value: '6' },
    { key: '7', value: '7' },
    { key: '8', value: '8' },
    { key: '9', value: '9' },
    { key: '10', value: '10' },
    { key: '11', value: '11' },
    { key: '12', value: '12' },
    { key: '13', value: '13' },
    { key: '14', value: '14' },
    { key: '15', value: '15' },
    { key: '16', value: '16' },
    { key: '17', value: '17' },
    { key: '18', value: '18' },
    { key: '19', value: '19' },
    { key: '20', value: '20' },
    { key: '21', value: '21' },
    { key: '22', value: '22' },
    { key: '23', value: '23' },
    { key: '24', value: '24' },
    { key: '25', value: '25' },
    { key: '26', value: '26' },
    { key: '27', value: '27' },
    { key: '28', value: '28' },
    { key: '29', value: '29' },
    { key: '30', value: '30' },
    { key: '31', value: '31' },
    { key: '32', value: '32' },
    { key: '33', value: '33' },
    { key: '34', value: '34' },
    { key: '35', value: '35' },
    { key: '36', value: '36' },
    { key: '37', value: '37' },
    { key: '38', value: '38' },
    { key: '39', value: '39' },
    { key: '40', value: '40' },
    { key: '41', value: '41' },
    { key: '42', value: '42' },
    { key: '43', value: '43' },
    { key: '44', value: '44' },
    { key: '45', value: '45' },
    { key: '46', value: '46' },
    { key: '47', value: '47' },
    { key: '48', value: '48' },
    { key: '49', value: '49' },
    { key: '50', value: '50' },
    { key: '51', value: '51' },
    { key: '52', value: '52' },
    { key: '53', value: '53' },
    { key: '54', value: '54' },
    { key: '55', value: '55' },
    { key: '56', value: '56' },
    { key: '57', value: '57' },
    { key: '58', value: '58' },
    { key: '59', value: '59' }
  ];

export const hourList = [
    { key: '*', value: 'Every Hour'},
    { key: '*/3', value: 'Every 3rd Hour'},
    { key: '*/6', value: 'Every 6th Hour'},
    { key: '*/12', value: 'Every 12th Hour'},
    { key: '0', value: '12 Midnight' },
    { key: '1', value: '1 AM' },
    { key: '2', value: '2 AM' },
    { key: '3', value: '3 AM' },
    { key: '4', value: '4 AM' },
    { key: '5', value: '5 AM' },
    { key: '6', value: '6 AM' },
    { key: '7', value: '7 AM' },
    { key: '8', value: '8 AM' },
    { key: '9', value: '9 AM' },
    { key: '10', value: '10 AM' },
    { key: '11', value: '11 AM' },
    { key: '12', value: '12 Noon' },
    { key: '13', value: '1 PM' },
    { key: '14', value: '2 PM' },
    { key: '15', value: '3 PM' },
    { key: '16', value: '4 PM' },
    { key: '17', value: '5 PM' },
    { key: '18', value: '6 PM' },
    { key: '19', value: '7 PM' },
    { key: '20', value: '8 PM' },
    { key: '21', value: '9 PM' },
    { key: '22', value: '10 PM' },
    { key: '23', value: '11 PM' }
  ];

export const dayList = [
    { key: '*', value: 'Every Day-Of-Month'},
    { key: '*/5', value: 'Every 5th Day-Of-Month'},
    { key: '*/10', value: 'Every 10th Day-Of-Month'},
    { key: '*/14', value: 'Every 14th Day-Of-Month'},
    { key:'1', value: '1' },
    { key:'2', value: '2' },
    { key:'3', value: '3' },
    { key:'4', value: '4' },
    { key:'5', value: '5' },
    { key:'6', value: '6' },
    { key:'7', value: '7' },
    { key:'8', value: '8' },
    { key:'9', value: '9' },
    { key:'10', value: '10' },
    { key:'11', value: '11' },
    { key:'12', value: '12' },
    { key:'13', value: '13' },
    { key:'14', value: '14' },
    { key:'15', value: '15' },
    { key:'16', value: '16' },
    { key:'17', value: '17' },
    { key:'18', value: '18' },
    { key:'19', value: '19' },
    { key:'20', value: '20' },
    { key:'21', value: '21' },
    { key:'22', value: '22' },
    { key:'23', value: '23' },
    { key:'24', value: '24' },
    { key:'25', value: '25' },
    { key:'26', value: '26' },
    { key:'27', value: '27' },
    { key:'28', value: '28' },
    { key:'29', value: '29' },
    { key:'30', value: '30' },
    { key:'31', value: '31' }
  ];
  
export const weekdayList = [
    { key: '*', value: 'Every Weekday'},
    { key: '1-5', value: 'Every Day from Monday to Friday'},
    { key: '0,6', value: 'Weekend Days'},
    { key: '1', value: 'Monday'},
    { key: '2', value: 'Tuesday'},
    { key: '3', value: 'Wednesday'},
    { key: '4', value: 'Thursday'},
    { key: '5', value: 'Friday'},
    { key: '6', value: 'Saturday' },
    { key: '0', value: 'Sunday' }
  ];

export const monthList = [
    { key: '*', value: 'Every Month'},
    { key: '*/3', value: 'Every 3 Months'},
    { key: '*/6', value: 'Every 6 Months'},
    { key: '1', value: 'January'},
    { key: '2', value: 'February'},
    { key: '3',  value: 'March'},
    { key: '4', value: 'April'},
    { key: '5', value: 'May'},
    { key: '6',  value: 'June'},
    { key: '7', value: 'July'},
    { key: '8', value: 'August'},
    { key: '9', value: 'September'},
    { key: '10', value: 'October'},
    { key: '11', value: 'November'},
    { key: '12', value: 'December'}
  ];


// WEBPACK FOOTER //
// ./src/app/shared/components/interval/interval-data.ts